<script lang="ts">
	import { page } from '$app/state';
	import { formatNumericString, validateQuantity } from '$lib/utils';

	interface Props {
		quantities: number[];
		quantity: number;
		multiplier?: number;
		unitNameSingle?: string;
		unitNamePlural?: string;
	}

	let {
		quantities,
		quantity,
		multiplier = 1,
		unitNameSingle = 'stuk',
		unitNamePlural = 'stuks'
	}: Props = $props();

	const translations = page.data.page.layout.translations.quantitySelector;

	let { isValid, nextValid, previousValid } = $derived(validateQuantity(quantities, quantity));
	let quantityToAdd = $derived(nextValid ? nextValid - quantity : 0);
	let quantityToRemove = $derived(previousValid ? quantity - previousValid : 0);
	let displayQuantityToAdd = $derived(quantityToAdd * multiplier);
	let displayQuantityToRemove = $derived(quantityToRemove * multiplier);
	let quantityMessage = $derived.by(() => {
		if (!previousValid) {
			return displayQuantityToAdd > 1
				? translations.addMultiple.replaceAll('%quantity%', strong(displayQuantityToAdd))
				: translations.addSingle.replaceAll('%quantity%', strong(displayQuantityToAdd));
		}

		if (!nextValid) {
			return displayQuantityToRemove > 1
				? translations.removeMultiple.replaceAll('%quantity%', strong(displayQuantityToRemove))
				: translations.removeSingle.replaceAll('%quantity%', strong(displayQuantityToRemove));
		}

		if (previousValid && nextValid) {
			if (displayQuantityToAdd === 1 && displayQuantityToRemove === 1) {
				return translations.addSingleOrRemoveSingle;
			} else if (displayQuantityToAdd > 1 && displayQuantityToRemove === 1) {
				return translations.addMultipleOrRemoveSingle.replaceAll(
					'%quantity%',
					strong(displayQuantityToAdd)
				);
			} else if (displayQuantityToAdd === 1 && displayQuantityToRemove > 1) {
				return translations.addSingleOrRemoveMultiple.replaceAll(
					'%quantity%',
					strong(displayQuantityToRemove)
				);
			} else {
				return translations.addMultipleOrRemoveMultiple
					.replaceAll('%quantity_add%', strong(displayQuantityToAdd))
					.replaceAll('%quantity_remove%', strong(displayQuantityToRemove));
			}
		}
	});

	function strong(value: string | number) {
		return `<strong>${value.toString()}</strong>`;
	}

	let message = $derived(
		quantityMessage
			.replaceAll('%product%', strong(unitNameSingle))
			.replaceAll('%products%', strong(unitNamePlural))
	);
</script>

{#if !isValid}
	{@html message}
{/if}
